// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-title {
  font-family: Manrope;
}
.card-img-div-top {
  width: 100%;
  /* height: 175px; */
  aspect-ratio: 4/2;
  border-radius: 4px;
  padding-top: 18px;
  padding-bottom: 6px;
}
.card-img-top {
  width: 100%;
  height: auto;
  aspect-ratio: 4/2;
  object-fit: contain;
}

.card-button {
  width: 100%;
  /* height: 40px; */
  border-radius: 5px;
  border: none;
  background-color: #28af4b;
  color: white;
  font-family: Manrope;
  padding: 4px 8px;
}

.card-button:hover {
  background-color: white;
  color: #28af4b;
  border: 1px solid #28af4b;
}
.remove-btn-promo-code {
  width: 100%;
  border-radius: 5px;
  border: none;
  font-family: Manrope;
  padding: 4px 8px;
}
.out-of-stock-text {
  text-align: end;
}
.outofstock {
  color: #c50000a2 !important;
  background-color: #dadada;
  border: none;
  outline: none;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  font-size: 12px;
  padding: 10px 12px;
}

.desaturate {
  filter: grayscale(100%);
}

.stock-card {
  height: 100%;
  /* z-index: 106; */
  background-color: #f8f8f8;
  border: 0.5px solid #f8f8f8;
  border-bottom-right-radius: 20px;
  border-radius: 20px;
  .card-body {
    padding: 0px;
  }
}
.stock-card-out-of-stock {
  height: 100%;
  /* z-index: 106; */
  border: none;
  background-color: #f8f8f8;
  border-bottom-right-radius: 20px;
  border-radius: 20px;
  .card-body {
    padding: 0px;
  }
}
.out-of-stock {
  color: #c50000a2;
  padding: 12px 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/fishCard/FishCard.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB;IACE,YAAY;EACd;AACF;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB;IACE,YAAY;EACd;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".card-title {\n  font-family: Manrope;\n}\n.card-img-div-top {\n  width: 100%;\n  /* height: 175px; */\n  aspect-ratio: 4/2;\n  border-radius: 4px;\n  padding-top: 18px;\n  padding-bottom: 6px;\n}\n.card-img-top {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 4/2;\n  object-fit: contain;\n}\n\n.card-button {\n  width: 100%;\n  /* height: 40px; */\n  border-radius: 5px;\n  border: none;\n  background-color: #28af4b;\n  color: white;\n  font-family: Manrope;\n  padding: 4px 8px;\n}\n\n.card-button:hover {\n  background-color: white;\n  color: #28af4b;\n  border: 1px solid #28af4b;\n}\n.remove-btn-promo-code {\n  width: 100%;\n  border-radius: 5px;\n  border: none;\n  font-family: Manrope;\n  padding: 4px 8px;\n}\n.out-of-stock-text {\n  text-align: end;\n}\n.outofstock {\n  color: #c50000a2 !important;\n  background-color: #dadada;\n  border: none;\n  outline: none;\n  border-top-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  font-size: 12px;\n  padding: 10px 12px;\n}\n\n.desaturate {\n  filter: grayscale(100%);\n}\n\n.stock-card {\n  height: 100%;\n  /* z-index: 106; */\n  background-color: #f8f8f8;\n  border: 0.5px solid #f8f8f8;\n  border-bottom-right-radius: 20px;\n  border-radius: 20px;\n  .card-body {\n    padding: 0px;\n  }\n}\n.stock-card-out-of-stock {\n  height: 100%;\n  /* z-index: 106; */\n  border: none;\n  background-color: #f8f8f8;\n  border-bottom-right-radius: 20px;\n  border-radius: 20px;\n  .card-body {\n    padding: 0px;\n  }\n}\n.out-of-stock {\n  color: #c50000a2;\n  padding: 12px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
